import { Component, OnInit } from '@angular/core';
import { SharedApiService } from '../../pages/shared/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PermissionService } from '../../@core/permission/permission.service';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  errorMessage: string = '';
  constructor(
    private fb: FormBuilder,
     private sharedApi: SharedApiService, 
     private router: Router, 
     private permissionService: PermissionService 
    ) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    // remove this code when prod publish
    // setTimeout(() => {
    //   this.loginForm.setValue({ username: 'test', password: 246369 });
    //   this.onSubmit();
    // }, 4000);
  }
  
  onSubmit(): void {
    if (this.loginForm.valid) {

      const { username, password } = this.loginForm.value;

      this.sharedApi.onlogin(username, password).subscribe((result) => {

        if (result.success && result.data) {

          const userData = result.data;

          this.sharedApi.saveData('userDetail', userData);

          this.sharedApi.getRolePermissions( userData.tenantId,userData.userRoleId ).subscribe((permRes) => {                             
            if (permRes.success) {            
             this.permissionService.setPermissions(permRes.data);
             localStorage.setItem('permissions', JSON.stringify(permRes.data));
             this.router.navigate(['/pages/lodge/dashboard']);
            }
          });

        } else {
          this.errorMessage = 'Login failed. Please check your credentials.';
        }

      }, error => {
        this.errorMessage = 'Error occurred';
        console.log(error);
      });
    }
  }
}
